// src/lib/history.js
import { sanitizeOptionalText } from './sanitize';

const KEY = 'pachicalc:runs';

export function loadRuns(limit = 50) {
  try {
    const data = localStorage.getItem(KEY);
    if (!data) return [];
    const runs = JSON.parse(data);
    return runs.slice(0, limit);
  } catch {
    return [];
  }
}

export function saveRun(run) {
  const runs = loadRuns();
  const id = Date.now().toString(36) + Math.random().toString(36).substring(2, 8);
  runs.unshift({
    id: id,
    createdAt: Date.now(),
    // 必須項目
    mode: run.mode, // "simple" | "detail"
    rotationRate: run.rotationRate,
    normalSpins: run.normalSpins,
    chanceSpins: run.chanceSpins ?? '', // simple時は空
    totalOutput: run.totalOutput,
    finalDifference: run.finalDifference,
    decreaseRate: run.decreaseRate ?? '', // simple時は空
    ballsPer1000: run.ballsPer1000,
    storeName: sanitizeOptionalText(run.storeName ?? ''),
    machineName: sanitizeOptionalText(run.machineName ?? ''),
  });
  localStorage.setItem(KEY, JSON.stringify(runs.slice(0, 50)));
}

export function deleteRun(id) {
  const runs = loadRuns().filter((r) => r.id !== id);
  localStorage.setItem(KEY, JSON.stringify(runs));
}

export function clearRuns() {
  localStorage.removeItem(KEY);
}
